<template>
  <div>
    <!-- 按钮区域 -->
    <div
      class="filter-section"
      style="display: flex; flex-wrap: wrap; margin: 0 -7.5px; margin-top: 20px"
    >
      <button
        type="button"
        class="el-button el-button--primary"
        @click="openAddDialog(1)"
      >
        <span>新增订单</span>
      </button>

      <button
        type="button"
        class="el-button el-button--primary"
        @click="openAddDialog(2)"
      >
        <span>新增退单</span>
      </button>
    </div>

    <!-- 多条件筛选区域 -->
    <div
      class="filter-section"
      style="display: flex; flex-wrap: wrap; margin: 0 -7.5px; margin-top: 20px"
    >
      <el-date-picker
        v-model="searchStartDate"
        type="date"
        placeholder="选择日期"
      >
      </el-date-picker>

      <span style="margin-left: 20px; margin-right: 20px">~</span>

      <el-date-picker
        v-model="searchStopDate"
        type="date"
        placeholder="选择日期"
      >
      </el-date-picker>

      <el-select
        v-model="searchCustomerId"
        filterable
        clearable
        placeholder="购买客户筛选"
        style="margin-left: 20px"
      >
        <el-option
          v-for="item in customerList"
          :key="item.objectId"
          :label="item.name"
          :value="item.objectId"
        >
        </el-option>
      </el-select>

      <el-input
        v-model="searchFreight"
        placeholder="货运部筛选"
        style="width: 200px; margin-left: 20px"
        clearable
      />
    </div>

    <div
      class="filter-section"
      style="display: flex; flex-wrap: wrap; margin: 0 -7.5px; margin-top: 20px"
    >
      <el-select
        v-model="searchOrderType"
        filterable
        placeholder="订单类型筛选"
      >
        <el-option
          v-for="item in orderTypeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="searchOrderStatus"
        filterable
        placeholder="订单状态筛选"
        style="margin-left: 20px"
      >
        <el-option
          v-for="item in orderStatusList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="searchPaymentMethod"
        filterable
        placeholder="支付方式筛选"
        style="margin-left: 20px"
      >
        <el-option
          v-for="item in paymentMethodList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-select
        v-model="searchPaymentStatus"
        filterable
        placeholder="结款状态筛选"
        style="margin-left: 20px"
      >
        <el-option
          v-for="item in paymentStatusList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>

      <el-button type="primary" @click="handleSearch" style="margin-left: 20px">
        筛选
      </el-button>
    </div>

    <!-- 新增订单弹窗 -->
    <el-dialog
      title="新增订单"
      :visible.sync="addDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <!-- 动态表单 -->
      <el-form ref="form" :model="addOrderForm">
        <div class="part-item-header">
          <el-form-item label="购买客户" prop="customerId">
            <el-select
              filterable
              @change="fetchAutomotivePartData"
              v-model="addOrderForm.customerId"
              placeholder="选择购买客户"
              style="width: 160px"
            >
              <el-option
                v-for="s in customerList"
                :key="s.objectId"
                :label="s.name"
                :value="s.objectId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="支付方式" prop="paymentMethod">
            <el-select
              filterable
              v-model="addOrderForm.paymentMethod"
              placeholder="选择支付方式"
              style="width: 100px"
            >
              <el-option
                v-for="s in paymentMethodList"
                :key="s.value"
                :label="s.label"
                :value="s.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="货运部" prop="freight">
            <el-input v-model="addOrderForm.freight" style="width: 160px" />
          </el-form-item>

          <el-form-item label="附加金额" prop="additionalAmount">
            <el-input
              v-model.number="addOrderForm.additionalAmount"
              placeholder="单价"
              @input="
                (val) =>
                  (addOrderForm.additionalAmount = val
                    .replace(/[^\d.]/g, '')
                    .replace(/\.{2,}/g, '.')
                    .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'))
              "
              style="width: 100px"
            ></el-input>
          </el-form-item>

          <el-form-item label="备注" prop="notes">
            <el-input v-model="addOrderForm.notes" style="width: 200px" />
          </el-form-item>
        </div>

        <div>
          <div class="part-item">
            <el-form-item>
              <div style="width: 200px; text-align: left">配件</div>
            </el-form-item>
            <el-form-item>
              <div style="width: 120px; text-align: left">车型</div>
            </el-form-item>
            <el-form-item>
              <div style="width: 120px; text-align: left">数量</div>
            </el-form-item>
            <el-form-item>
              <div style="width: 60px; text-align: left">单位</div>
            </el-form-item>
            <el-form-item>
              <div style="width: 80px; text-align: left">单价</div>
            </el-form-item>
            <el-form-item>
              <div style="width: 180px; text-align: left">备注</div>
            </el-form-item>
          </div>

          <div
            v-for="(item, index) in addOrderForm.orderDetailList"
            :key="index"
            class="part-item"
          >
            <el-button
              type="text"
              icon="el-icon-close"
              width="100"
              @click="removeItem(1, index)"
            ></el-button>

            <el-form-item :prop="`orderDetailList.${index}.automotivePartId`">
              <div style="width: 200px; text-align: left">
                {{ item.automotivePartName }}
              </div>
            </el-form-item>

            <el-form-item
              :prop="`orderDetailList.${index}.carModelCompatibility`"
            >
              <div style="width: 120px; text-align: left">
                {{ item.carModelCompatibility }}
              </div>
            </el-form-item>

            <el-form-item :prop="`orderDetailList.${index}.quantity`">
              <el-input
                v-model.number="item.quantity"
                placeholder="数量"
                @input="(val) => (item.quantity = val.replace(/[^\d]/g, ''))"
                style="width: 120px"
              ></el-input>
            </el-form-item>

            <el-form-item :prop="`orderDetailList.${index}.unit`">
              <div style="width: 60px; text-align: left">{{ item.unit }}</div>
            </el-form-item>

            <el-form-item :prop="`orderDetailList.${index}.sellPrice`">
              <div style="width: 80px; text-align: left">
                {{ item.sellPrice }}
              </div>
            </el-form-item>

            <el-form-item :prop="`orderDetailList.${index}.remark`">
              <div style="width: 180px; text-align: left">
                {{ item.remark }}
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="addSubmitFormConfirm"
          :loading="addSubmitting"
        >
          提交
        </el-button>
        <el-button
          type="primary"
          @click="addSubmitFormAndPrintConfirm"
          :loading="addSubmitting"
        >
          提交并打印
        </el-button>
      </div>
    </el-dialog>

    <!-- 编辑订单弹窗 -->
    <el-dialog
      title="编辑订单"
      :visible.sync="editDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <!-- 动态表单 -->
      <el-form ref="form" :model="editOrderForm">
        <div class="part-item-header">
          <el-form-item label="购买客户" prop="customerId">
            <el-select
              filterable
              v-model="editOrderForm.customerId"
              placeholder="选择购买客户"
              style="width: 160px"
              disabled
            >
              <el-option
                v-for="s in customerList"
                :key="s.objectId"
                :label="s.name"
                :value="s.objectId"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="支付方式" prop="paymentMethod">
            <el-select
              filterable
              v-model="editOrderForm.paymentMethod"
              placeholder="选择支付方式"
              style="width: 100px"
            >
              <el-option
                v-for="s in paymentMethodList"
                :key="s.value"
                :label="s.label"
                :value="s.value"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="货运部" prop="freight">
            <el-input v-model="editOrderForm.freight" style="width: 160px" />
          </el-form-item>

          <el-form-item label="附加金额" prop="additionalAmount">
            <el-input
              v-model.number="editOrderForm.additionalAmount"
              placeholder="单价"
              @input="
                (val) =>
                  (editOrderForm.additionalAmount = val
                    .replace(/[^\d.]/g, '')
                    .replace(/\.{2,}/g, '.')
                    .replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3'))
              "
              style="width: 100px"
            ></el-input>
          </el-form-item>

          <el-form-item label="备注" prop="notes">
            <el-input v-model="editOrderForm.notes" style="width: 200px" />
          </el-form-item>
        </div>

        <div>
          <div class="part-item">
            <el-form-item>
              <div style="width: 200px; text-align: left">配件</div>
            </el-form-item>
            <el-form-item>
              <div style="width: 120px; text-align: left">车型</div>
            </el-form-item>
            <el-form-item>
              <div style="width: 120px; text-align: left">数量</div>
            </el-form-item>
            <el-form-item>
              <div style="width: 60px; text-align: left">单位</div>
            </el-form-item>
            <el-form-item>
              <div style="width: 80px; text-align: left">单价</div>
            </el-form-item>
            <el-form-item>
              <div style="width: 180px; text-align: left">备注</div>
            </el-form-item>
          </div>

          <div
            v-for="(item, index) in editOrderForm.orderDetailList"
            :key="index"
            class="part-item"
          >
            <el-button
              type="text"
              icon="el-icon-close"
              width="100"
              @click="removeItem(2, index)"
            ></el-button>

            <el-form-item :prop="`orderDetailList.${index}.automotivePartId`">
              <div style="width: 200px; text-align: left">
                {{ item.automotivePartName }}
              </div>
            </el-form-item>

            <el-form-item
              :prop="`orderDetailList.${index}.carModelCompatibility`"
            >
              <div style="width: 120px; text-align: left">
                {{ item.carModelCompatibility }}
              </div>
            </el-form-item>

            <el-form-item :prop="`orderDetailList.${index}.quantity`">
              <el-input
                v-model.number="item.quantity"
                placeholder="数量"
                @input="(val) => (item.quantity = val.replace(/[^\d]/g, ''))"
                style="width: 120px"
              ></el-input>
            </el-form-item>

            <el-form-item :prop="`orderDetailList.${index}.unit`">
              <div style="width: 60px; text-align: left">{{ item.unit }}</div>
            </el-form-item>

            <el-form-item :prop="`orderDetailList.${index}.sellPrice`">
              <div style="width: 80px; text-align: left">
                {{ item.sellPrice }}
              </div>
            </el-form-item>

            <el-form-item :prop="`orderDetailList.${index}.remark`">
              <div style="width: 180px; text-align: left">
                {{ item.remark }}
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="editSubmitForm"
          :loading="editSubmitting"
        >
          提交保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 表格 -->
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
      v-loading="loading"
    >
      <el-table-column
        prop="billingDate"
        label="开单日期"
        width="160"
        :formatter="(row) => $options.filters.formatDate(row.billingDate)"
      ></el-table-column>

      <!-- 类型字段转换列 -->
      <el-table-column
        prop="customerId"
        label="购买客户"
        width="120"
        :formatter="formatCustomerText"
      ></el-table-column>

      <el-table-column
        prop="totalAmount"
        label="总金额"
        width="100"
      ></el-table-column>

      <el-table-column
        prop="freight"
        label="货运部"
        width="100"
      ></el-table-column>

      <!-- 类型字段转换列 -->
      <el-table-column
        prop="orderType"
        label="订单类型"
        width="100"
        :formatter="formatOrderTypeText"
      ></el-table-column>

      <!-- 类型字段转换列 -->
      <el-table-column
        prop="orderStatus"
        label="订单状态"
        width="100"
        :formatter="formatOrderStatusText"
      ></el-table-column>

      <!-- 类型字段转换列 -->
      <el-table-column
        prop="paymentMethod"
        label="支付方式"
        width="100"
        :formatter="formatPaymentMethodText"
      ></el-table-column>

      <!-- 类型字段转换列 -->
      <el-table-column
        prop="paymentStatus"
        label="结款状态"
        width="100"
        :formatter="formatPaymentStatusText"
      ></el-table-column>

      <el-table-column label="操作" width="700">
        <template #default="{ row }">
          <el-button type="primary" size="mini" @click="print(row)">
            打印订单
          </el-button>

          <el-button
            type="primary"
            size="mini"
            @click="editOrderStatus(2, row)"
            :disabled="!allowOrderStatusOperate(row)"
            v-if="row.orderType == 1"
          >
            确认发货
          </el-button>

          <el-button
            type="primary"
            size="mini"
            @click="openEditDialog(row)"
            :disabled="!allowOrderStatusOperate(row)"
          >
            编辑明细
          </el-button>

          <el-button
            type="primary"
            size="mini"
            @click="editOrderStatus(4, row)"
            :disabled="!allowOrderStatusOperate(row)"
            v-if="row.orderType == 2"
          >
            确认收货
          </el-button>

          <el-popconfirm
            title="确定已经收到/支付货款了吗？"
            confirm-button-text="确定"
            cancel-button-text="取消"
            :disabled="!allowPaymentStatusOperate(row)"
            @confirm="editPaymentStatus(row)"
          >
            <template #reference>
              <el-button
                type="danger"
                size="mini"
                :disabled="!allowPaymentStatusOperate(row)"
                style="margin-left: 10px"
                >确认结款</el-button
              >
            </template>
          </el-popconfirm>

          <el-popconfirm
            title="确定要删除订单？"
            confirm-button-text="确定"
            cancel-button-text="取消"
            :disabled="!allowOrderStatusOperate(row)"
            @confirm="deleteOrder(row)"
          >
            <template #reference>
              <el-button
                type="danger"
                size="mini"
                :disabled="!allowOrderStatusOperate(row)"
                style="margin-left: 10px"
                >删除订单</el-button
              >
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>

<script>
import axios from "axios";

export default {
    filters: {
    formatDate(value) {
      if (!value) return "";
      return value.split("T")[0];
    },
  },
  data() {
    return {
      tableData: [], // 表格数据
      automotivePartData: [],

      searchStartDate: Date.now(),
      searchStopDate: Date.now(),
      searchFreight: "",
      searchCustomerId: "",
      searchOrderType: 0,
      searchOrderStatus: 0,
      searchPaymentMethod: 0,
      searchPaymentStatus: 0,

      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 0, // 总数据量
      loading: false, // 加载状态

      baseWidth: "500px",
      largeWidth: "900px",

      printOrderId: "",

      addDialogVisible: false,
      addSubmitting: false,
      addOrderForm: {
        customerId: "",
        orderType: 1,
        freight: "",
        paymentMethod: 1,
        additionalAmount: 0,
        orderDetailList: [this.emptyItem()],
        notes: "",
      },

      editDialogVisible: false,
      editSubmitting: false,
      editOrderForm: {
        objectId: "",
        customerId: "",
        freight: "",
        orderType: 1,
        paymentMethod: 1,
        additionalAmount: 0,
        orderDetailList: [this.emptyItem()],
        notes: "",
      },

      customerList: [],
      customerMap: new Map(),

      supplierList: [],
      supplierMap: new Map(),

      orderTypeList: [
        { value: 0, label: "订单类型【全部】" },
        { value: 1, label: "普通订单" },
        { value: 2, label: "退货订单" },
      ],
      orderTypeMap: new Map([
        [0, ""],
        [1, "普通订单"],
        [2, "退货订单"],
      ]),

      orderStatusList: [
        { value: 0, label: "发货状态【全部】" },
        { value: 1, label: "待发货" },
        { value: 2, label: "已发货" },
        { value: 3, label: "待退货" },
        { value: 4, label: "已退货" },
      ],
      orderStatusMap: new Map([
        [0, ""],
        [1, "待发货"],
        [2, "已发货"],
        [3, "待退货"],
        [4, "已退货"],
      ]),

      paymentMethodList: [
        { value: 0, label: "支付方式【全部】" },
        { value: 1, label: "现金" },
        { value: 2, label: "记账" },
        { value: 3, label: "代收" },
        { value: 4, label: "微信支付" },
      ],
      paymentMethodMap: new Map([
        [0, ""],
        [1, "现金"],
        [2, "记账"],
        [3, "代收"],
        [4, "微信支付"],
      ]),

      paymentStatusList: [
        { value: 0, label: "结款状态【全部】" },
        { value: 1, label: "未结款" },
        { value: 2, label: "已结款" },
      ],
      paymentStatusMap: new Map([
        [0, ""],
        [1, "未结款"],
        [2, "已结款"],
      ]),
    };
  },

  created() {
    this.fetchData();
    this.fetchCustomerData();
    this.fetchSupplierData();
  },

  computed: {
    editDialogWidth() {
      return this.editOrderForm.orderDetailList.length > 1
        ? this.largeWidth
        : this.baseWidth;
    },
  },

  methods: {
    // 获取表格数据
    async fetchData() {
      try {
        this.loading = true;
        const params = {
          startDate: new Date(this.searchStartDate).toLocaleDateString("en-CA"),
          stopDate: new Date(this.searchStopDate).toLocaleDateString("en-CA"),
          orderNumber: this.searchOrderNumber,
          customerId: this.searchCustomerId,
          orderType: this.searchOrderType,
          orderStatus: this.searchOrderStatus,
          freight: this.searchFreight,
          paymentMethod: this.searchPaymentMethod,
          paymentStatus: this.searchPaymentStatus,
          currentPage: this.currentPage,
          pageSize: this.pageSize,
        };
        const response = await axios.post(
          "/api/OrderInfo/getOrderInfoList",
          params
        );

        this.tableData = response.data.result;
        this.total = response.data.total;
      } finally {
        this.loading = false;
      }
    },

    // 客户数据加载
    async fetchCustomerData() {
      try {
        const response = await axios.get("/api/Customer/getAllCustomer");

        this.customerList = response.data.result;

        this.customerMap = new Map();
        for (var item of response.data.result) {
          this.customerMap.set(item.objectId, item.name);
        }
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },

    // 供应商数据加载
    async fetchSupplierData() {
      try {
        const response = await axios.get("/api/Supplier/getAllSupplier");

        this.supplierList = response.data.result;

        this.supplierMap = new Map();
        for (var item of response.data.result) {
          this.supplierMap.set(item.objectId, item.name);
        }
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },

    // 格式化客户字段
    formatCustomerText(row) {
      return this.customerMap.get(row.customerId) || "未知客户";
    },

    // 格式化供应商字段
    formatSupplierText(row) {
      return this.supplierMap.get(row.supplierId) || "未知供应商";
    },

    // 格式化订单类型字段
    formatOrderTypeText(row) {
      return this.orderTypeMap.get(row.orderType) || "未知状态";
    },

    // 格式化订单状态字段
    formatOrderStatusText(row) {
      return this.orderStatusMap.get(row.orderStatus) || "未知状态";
    },

    // 格式化支付方式字段
    formatPaymentMethodText(row) {
      return this.paymentMethodMap.get(row.paymentMethod) || "未知状态";
    },

    // 格式化借款状态字段
    formatPaymentStatusText(row) {
      return this.paymentStatusMap.get(row.paymentStatus) || "未知状态";
    },

    // 切换每页数量
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },

    // 切换页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },

    // 搜索
    handleSearch() {
      this.fetchData();
    },

    // 打开新增弹窗
    openAddDialog(orderType) {
      this.addDialogVisible = true;
      this.addOrderForm.customerId = "";
      this.addOrderForm.orderType = orderType;
      this.addOrderForm.freight = "";
      this.addOrderForm.paymentMethod = 1;
      this.addOrderForm.orderDetailList = [this.emptyItem()];
    },

    // 行数据初始化
    emptyItem() {
      return {
        automotivePartId: "",
        quantity: 1,
      };
    },

    // 移除条目
    removeItem(type, index) {
      if (type == 1) {
        this.addOrderForm.orderDetailList.splice(index, 1);
      } else {
        this.editOrderForm.orderDetailList.splice(index, 1);
      }
    },

    // 获取可出库的配件信息
    async fetchAutomotivePartData() {
      this.automotivePartData = [];
      this.addOrderForm.orderDetailList = [];

      try {
        const response = await axios.get(
          "/api/AutomotivePart/getInventoryAccessoryListByCustomer?customerId=" +
            this.addOrderForm.customerId
        );

        this.automotivePartData = response.data.result;

        for (var detail of response.data.result) {
          this.addOrderForm.orderDetailList.push({
            automotivePartId: detail.objectId,
            automotivePartName: detail.partName,
            carModelCompatibility: detail.carModelCompatibility,
            quantity: detail.stockQuantity,
            unit: detail.unit,
            unitPrice: detail.unitPrice,
            sellPrice: detail.sellPrice,
            remark: detail.remark,
          });
        }
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },

    async addSubmitFormConfirm(){
      var needConfirm = await this.addSubmitFormConfirmCondition();

      if (needConfirm) {
        this.$confirm('存在配件售价低于进价，是否确定继续创建订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 用户点击了【确定】，执行新增
          this.addSubmitForm();
        }).catch(() => {
          // 用户点击了【取消】或关闭了弹窗
          this.$message.info('已取消操作');
        });
      } else {
        // 3. 不需要确认，直接执行新增
        this.addSubmitForm();
      }
    },

    // 新增订单
    async addSubmitForm() {
      try {
        this.addSubmitting = true;

        var submitDetails = [];
        for (var detail of this.addOrderForm.orderDetailList) {
          submitDetails.push({
            automotivePartId: detail.automotivePartId,
            quantity: detail.quantity,
          });
        }

        var submmitInfo = {
          customerId: this.addOrderForm.customerId,
          orderType: this.addOrderForm.orderType,
          paymentMethod: this.addOrderForm.paymentMethod,
          additionalAmount: this.addOrderForm.additionalAmount,
          freight: this.addOrderForm.freight,
          notes: this.addOrderForm.notes,
          orderDetailList: submitDetails,
        };

        // 调用批量新增接口
        var response = await axios.post(
          "/api/OrderInfo/addOrderInfo",
          submmitInfo
        );

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("新增订单成功");

          await this.fetchData();

          this.addDialogVisible = false;
          this.printOrderId = response.data.result.message;
        } else {
          this.$message.error(`新增订单失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("提交失败:", error);
        this.$message.error(error.response?.data?.message || "提交失败");
      } finally {
        this.addSubmitting = false;
      }
    },

    // 新增订单并打印
    async addSubmitFormAndPrintConfirm() {
      var needConfirm = await this.addSubmitFormConfirmCondition();

      if (needConfirm) {
        this.$confirm('存在配件售价低于进价，是否确定继续创建订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 用户点击了【确定】，执行新增
          this.addSubmitFormAndPrint();
        }).catch(() => {
          // 用户点击了【取消】或关闭了弹窗
          this.$message.info('已取消操作');
        });
      } else {
        // 3. 不需要确认，直接执行新增
        this.addSubmitFormAndPrint();
      }
    },

    // 新增订单并打印
    async addSubmitFormAndPrint() {
      this.printOrderId = "";

      await this.addSubmitForm();

      if (this.printOrderId != "") {
        await this.printById(this.printOrderId);
      }
    },

    async addSubmitFormConfirmCondition(){
      for (var detail of this.addOrderForm.orderDetailList) {
        const sellPrice = Number(detail.sellPrice);
        const unitPrice = Number(detail.unitPrice);
        
        if(sellPrice < unitPrice)
          return true;
      }

      return false;
    },

    // 订单打印
    async print(row) {
      try {
        // 1. 获取数据
        const response = await axios.get(
          "/api/Print/generateOrder?orderId=" + row.objectId
        );
        const orderData = response.data;

        // 3. 创建打印窗口
        const printWindow = window.open("", "_blank");
        printWindow.document.write(orderData);
        printWindow.document.close();
        printWindow.print();
        printWindow.close();
      } catch (error) {
        console.error("打印失败:", error);
      }
    },

    // 订单打印
    async printById(id) {
      try {
        // 1. 获取数据
        const response = await axios.get(
          "/api/Print/generateOrder?orderId=" + id
        );
        const orderData = response.data;

        // 3. 创建打印窗口
        const printWindow = window.open("", "_blank");
        printWindow.document.write(orderData);
        printWindow.document.close();
        printWindow.print();
        printWindow.close();
      } catch (error) {
        console.error("打印失败:", error);
      }
    },

    // 是否允许更新订单状态或新增明细或删除订单操作
    allowOrderStatusOperate(row) {
      return row.orderStatus == 1 || row.orderStatus == 3;
    },

    // 是否允许更新结款状态操作
    allowPaymentStatusOperate(row) {
      return (
        row.paymentStatus == 1 && (row.orderStatus == 2 || row.orderStatus == 4)
      );
    },

    // 更新收货状态
    async editOrderStatus(status, row) {
      try {
        // 调用更新接口
        var response = await axios.post("/api/OrderInfo/editOrderStatus", {
          orderStatus: status,
          orderIds: [row.objectId],
        });

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("更新成功");

          await this.fetchData();
        } else {
          this.$message.error(`更新失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("更新失败:", error);
        this.$message.error(error.response?.data?.message || "更新失败");
      }
    },

    // 更新结款状态
    async editPaymentStatus(row) {
      try {
        // 调用更新接口
        var response = await axios.post("/api/OrderInfo/editPaymentStatus", [
          row.objectId,
        ]);

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("更新成功");

          await this.fetchData();
        } else {
          this.$message.error(`更新失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("更新失败:", error);
        this.$message.error(error.response?.data?.message || "更新失败");
      }
    },

    // 删除订单
    async deleteOrder(row) {
      try {
        // 调用更新接口
        var response = await axios.post("/api/OrderInfo/deleteOrderInfo", [
          row.objectId,
        ]);

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("删除成功");

          await this.fetchData();
        } else {
          this.$message.error(`删除失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("删除失败:", error);
        this.$message.error(error.response?.data?.message || "删除失败");
      }
    },

    // 打开编辑弹窗
    openEditDialog(row) {
      this.editOrderForm.objectId = row.objectId;
      this.editOrderForm.customerId = row.customerId;
      this.editOrderForm.orderType = row.orderType;
      this.editOrderForm.paymentMethod = row.paymentMethod;
      this.editOrderForm.additionalAmount = row.additionalAmount;
      this.editOrderForm.freight = row.freight;
      this.editOrderForm.notes = row.notes;

      this.fetchEditAutomotivePartData();

      this.editDialogVisible = true;
    },

    // 获取编辑订单时的可出库配件信息
    async fetchEditAutomotivePartData() {
      this.automotivePartData = [];
      this.editOrderForm.orderDetailList = [];

      try {
        const response = await axios.get(
          "/api/OrderInfo/getEditOrderInfo?orderId=" +
            this.editOrderForm.objectId
        );

        this.automotivePartData = response.data.automotiveParts;

        for (var detail of response.data.orderDetails) {
          this.editOrderForm.orderDetailList.push({
            automotivePartId: detail.objectId,
            automotivePartName: detail.partName,
            carModelCompatibility: detail.carModelCompatibility,
            quantity: detail.stockQuantity,
            unit: detail.unit,
            sellPrice: detail.sellPrice,
            remark: detail.remark,
          });
        }
      } catch (error) {
        console.error("数据加载失败:", error);
      }
    },

    // 编辑订单
    async editSubmitForm() {
      try {
        this.editSubmitting = true;

        var submitDetails = [];
        for (var detail of this.editOrderForm.orderDetailList) {
          submitDetails.push({
            automotivePartId: detail.automotivePartId,
            quantity: detail.quantity,
          });
        }

        var submmitInfo = {
          orderId: this.editOrderForm.objectId,
          paymentMethod: this.editOrderForm.paymentMethod,
          additionalAmount: this.editOrderForm.additionalAmount,
          freight: this.editOrderForm.freight,
          notes: this.editOrderForm.notes,
          orderDetailList: submitDetails,
        };

        // 调用编辑接口
        var response = await axios.post(
          "/api/OrderInfo/editOrderInfo",
          submmitInfo
        );

        // 根据接口返回处理
        if (response.data.result.code == 200) {
          this.$message.success("更新订单成功");

          await this.fetchData();

          this.editDialogVisible = false;
        } else {
          this.$message.error(`更新订单失败: ${response.data.result.message}`);
        }
      } catch (error) {
        console.error("更新失败:", error);
        this.$message.error(error.response?.data?.message || "更新失败");
      } finally {
        this.editSubmitting = false;
      }
    },
  },
};
</script>

<style scoped>
@media print {
  body * {
    visibility: hidden;
  }

  #printArea,
  #printArea * {
    visibility: visible;
  }

  #printArea {
    position: absolute;
    left: 0;
    top: 0;
    width: 100mm;
    /* 根据实际小票尺寸调整 */
  }
}

.filter-section {
  margin-bottom: 20px;
}

.el-col {
  margin-bottom: 10px;
}

.error-alert {
  margin-bottom: 20px;
}

.part-item-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
}

.part-item-header >>> .el-form-item {
  margin-bottom: 0;
  margin-right: 15px;
}

.container {
  display: flex;
  width: 900px;
  flex-wrap: wrap;
}

.part-item {
  display: flex;
  width: 400px;
  align-items: center;
}

.part-item >>> .el-form-item {
  margin-bottom: 0;
  margin-right: 15px;
}

.action-bar {
  text-align: center;
  margin-top: 20px;
}
</style>
